import { render, staticRenderFns } from "./MatchGSRPLikelyReferral.vue?vue&type=template&id=3eaafbec&"
import script from "./MatchGSRPLikelyReferral.vue?vue&type=script&lang=ts&"
export * from "./MatchGSRPLikelyReferral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports